module.exports = __webpack_public_path__ + "img/company1.20103946.png";